module.exports = __webpack_public_path__ + "static/media/x.80841d24.svg";